import { atom } from 'jotai';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';

export interface UserData {
  userAccount: string;
  userNickName: string;
  userSort: string;
  userDetail: string;
  userType: string;
  grade: string;
  authInstitution: string;
  authChurch: string;
  authDepartment: string;
  authGroup: string;
}

export const loginStateAtom = atomWithStorage('loginState', false, createJSONStorage<boolean>(() => sessionStorage));

export const loginPathAtom = atomWithStorage('loginPath', '', createJSONStorage<string>(() => sessionStorage));

export const userDataAtom = atomWithStorage<UserData>('userData', {
  userAccount: '',
  userNickName: '',
  userSort: '',
  userDetail: '',
  userType: '',
  grade: '',
  authInstitution: '',
  authChurch: '',
  authDepartment: '',
  authGroup: '',
}, createJSONStorage<UserData>(() => sessionStorage));

export const kaKaoLoginDataAtom = atom({
  APIKEY: '0ceb02a4c2ba5343e679e135b09a649a',
  REDIRECT_URI_Auth: 'https://ministermore.co.kr/login/loginsns', 
  // REDIRECT_URI_Auth: 'http://localhost:3000/login/loginsns', 
});

export const naverLoginDataAtom = atom({
  CLIENTID: 'oC2ypvaePVUFUTmJueXq',
  SECRET: 'IlPy8cgw0i',
  REDIRECT_URI_Auth: 'https://ministermore.co.kr/login/loginsns',
});
